import React from 'react'
import { useParams } from 'react-router-dom';
import ApiUrl from '../../../configTools/apiUrl';
import { Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useState,useEffect } from 'react';
import ScreenSizes from '../../../configTools/screenSizes';
import BlueButton from '../../../components/forms/blueButton';
import GreenButton from '../../../components/forms/greenButton';
import {ReactComponent as ViewIcon} from '../../../images/icons/view.svg'
import {ReactComponent as EditIcon} from '../../../images/icons/edit.svg'

const Index = () => {
    const {active} = useParams();
    const widths = window.innerWidth;
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [feeds, setFeeds] = useState([]);
    const [feedpage, setFeedPage] = useState(0);
    const [feedHasMore, setFeedHasMore] = useState(true);

    const getmore_Feeds = ()=>{
        const uri = active == 1 ? ApiUrl.API_URL_ListingAdmin : ApiUrl.API_URL_ListingActive;
        fetch(uri+"/"+feedpage,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
        let prevfeeds = feeds;
        for (let index = 0; index < data.responce.length; index++) {
            const element = data.responce[index];
            prevfeeds.push(element);
        }
        setFeeds(prevfeeds);
        setFeedPage(feedpage+1);
        if(data.responce.length === 0){
            setFeedHasMore(false);
        }
        else{
            setFeedHasMore(true);
        }
        });
    }

    useEffect(() => {
    if(User !== null){
        const uri = active == 1 ? ApiUrl.API_URL_ListingAdmin : ApiUrl.API_URL_ListingActive;
        fetch(uri+"/0",{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
        setFeeds(data.responce);
        setFeedPage(1);
        if(data.responce.length === 0){
            setFeedHasMore(false);
        }
        else{
            setFeedHasMore(true);
        }
        });
    }
    },[active])
  return (
    <>
          <InfiniteScroll 
                dataLength={feeds.length}
                next={getmore_Feeds}
                hasMore={feedHasMore}
                loader={<h1></h1>}
            >
            <div className='admin_forms_main_container'>
              <div className='public_home_product_grid_1_container'>
                <div className='public_home_product_grid_4_products'>
                {
                    feeds.map((Product,index)=>{
                        return(
                            <div style={{width:String((100/(parseInt(widths > ScreenSizes.Mobile? 5 : 3))))+"%", padding:"0.1%"}} key={index}>
                            <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+Product.image})`}}>
                                <div className='public_home_product_grid_1_products_item_overlay'>
                                    <div className='public_home_product_grid_1_products_item_overlay_price'>
                                        <div className='listing_bottom_buttons'>
                                            <Link to={'/product/'+Product.slug} target="_blank" rel="noopener noreferrer"><BlueButton Value={<ViewIcon width={'10px'} height={'10px'}/>}/></Link>
                                            <Link to={'/admin/products/listing/edit/'+Product.id}><GreenButton Value={<EditIcon width={'10px'} height={'10px'}/>}/></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        )
                    })
                }
                </div>
              </div>
            </div>
           </InfiniteScroll>
    </>
  )
}

export default Index
